import { Box } from '@everlywell/ui-kit';
import React from 'react';

export type YouTubeEmbedProps = {
  videoUrl?: string;
};

export default function YouTubeEmbed({ videoUrl }: YouTubeEmbedProps) {
  return (
    <Box
      position="relative"
      paddingTop="56.25%" // 16:9 aspect ratio
    >
      <Box
        as="iframe"
        src={videoUrl}
        title="YouTube video player"
        position="absolute"
        top="0"
        left="0"
        width="100%"
        height="100%"
        border="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </Box>
  );
}
